import api from "./client";

export interface ConnectionService {
  id: string;
  organization_id: string;
  provider: "azure" | "aws" | "gcp" | "azuredevops" | "fabric" | "purview";
  name: string;
  credentials: any;
  is_active: boolean;
  last_tested_at?: string;
  test_status?: "success" | "failed";
  test_message?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateConnectionData {
  provider: "azure" | "aws" | "gcp" | "azuredevops" | "fabric" | "purview";
  name: string;
  credentials: any;
}

export interface UpdateConnectionData {
  name?: string;
  credentials?: any;
}

export interface TestConnectionData {
  provider: "azure" | "aws" | "gcp" | "azuredevops" | "fabric" | "purview";
  credentials: any;
}

export async function getConnections(): Promise<ConnectionService[]> {
  const response = await api.get("/api/connections");
  return response.data.connections ?? response.data;
}

export async function getConnection(id: string): Promise<ConnectionService> {
  const response = await api.get(`/api/connections/${id}`);
  return response.data.connection ?? response.data;
}

export async function getConnectionWithCredentials(id: string): Promise<ConnectionService> {
  const response = await api.get(`/api/connections/${id}?withCredentials=true`);
  return response.data.connection ?? response.data;
}

export async function createConnection(data: CreateConnectionData): Promise<ConnectionService> {
  const response = await api.post("/api/connections", data);
  return response.data.connection ?? response.data;
}

export async function updateConnection(
  id: string,
  data: UpdateConnectionData
): Promise<ConnectionService> {
  const response = await api.patch(`/api/connections/${id}`, data);
  return response.data.connection ?? response.data;
}

export async function testConnection(id: string): Promise<{ success: boolean; message: string; error?: string }> {
  const response = await api.post(`/api/connections/${id}/test`);
  // Backend returns { message: '...', result: { success, message, error } }
  return response.data.result ?? response.data;
}

export async function testCredentials(
  data: TestConnectionData
): Promise<{
  message: string;
  result: {
    success: boolean;
    provider: string;
    message: string;
    details?: any;
    error?: string;
  }
}> {
  const response = await api.post("/api/connections/test-credentials", data);
  return response.data;
}

export async function toggleConnection(id: string): Promise<void> {
  await api.post(`/api/connections/${id}/toggle`);
}

export async function deleteConnection(id: string): Promise<void> {
  await api.delete(`/api/connections/${id}`);
}
